import { GetServerSideProps } from 'next';
import { Fragment } from 'react';

import { wrapper } from 'src/redux/store/store';
import { getSimplePage } from 'src/api/pageApi';
import { PageSetUpInStorageConfig, ServerSideRenderingContext } from 'types/objectTypes';
import { CustomerType } from 'constants/enums';
import { calculateCustomerType } from 'lib/session.service';
import { setUpPageInStore, writeRedirectHtmlCode } from 'lib/page.service';
import { fileExtension } from 'lib/regexp.service';
import withMiddleware, { commonMiddleware, postCommonMiddleware } from 'src/shared/lib/middleware/combiner';
import { setDefaultCacheBehavior } from 'lib/storage.service';

const handler = async ({
  // @ts-ignore
  req,
  res,
  path,
  store,
  params,
  preview = false,
}: ServerSideRenderingContext): Promise<any> => {
  const session = req?.session?.getSession();
  const customerType = calculateCustomerType(req.session);

  if (session) {
    writeRedirectHtmlCode(res, `${process.env.BASE_SERVER_URL}/echomepage`);
  }

  const isAuthorized = customerType === CustomerType.EC;
  try {
    const { slug: parametersSlug } = params || { slug: '' };
    const slug = (Array.isArray(parametersSlug))
      ? parametersSlug.join('')
      : parametersSlug as string;

    if (!slug || slug.match(fileExtension)) {
      return { notFound: true };
    }

    const page = await getSimplePage({ preview, slug, customerType, path });

    if (page) {
      const pageSetUpConfig: PageSetUpInStorageConfig = {
        page,
        session,
        slug,
        store,
        headers: req.headers,
        isAuthorized,
      };
      setUpPageInStore(pageSetUpConfig);
      setDefaultCacheBehavior(120, res);

      return { props: {} };
    }

    return { notFound: true };
  } catch (e) {
    console.error(e);

    return { props: {} };
  }
};

export const getServerSideProps: GetServerSideProps = wrapper
// @ts-ignore
  .getServerSideProps(withMiddleware(
    handler,
    { prior: commonMiddleware, post: postCommonMiddleware },
  ));

export default Fragment;
